import * as z from "zod";

import { StoreSchema } from "../shared/store";

/** Matches POST /partner/v1/stores; the server canonicalizes storeUrl. */
export const createStore = {
  name: "createStore" as const,
  input: z.object({
    name: z.string().trim().min(1).max(200),
    email: z.email(),
    phone: z.string().trim().min(1),
    storeUrl: z.string().trim().min(1).max(255),
    address: z.object({
      name: z.string().trim().min(1),
      street1: z.string().trim().min(1),
      street2: z.string().trim().default(""),
      city: z.string().trim().min(1),
      state: z.string().trim(),
      zip: z.string().trim(),
      country: z.string().trim().length(2),
      countryName: z.string().trim().min(1),
    }),
  }),
  output: z.object({ store: StoreSchema }),
};
